var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C4.475 20 0 15.525 0 10C0 4.475 4.475 0 10 0C15.525 0 20 4.475 20 10C20 15.525 15.525 20 10 20Z",
    fill: "#FFBE41"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6667 15C11.6667 15.4603 11.2936 15.8333 10.8333 15.8333H9.16667C8.70642 15.8333 8.33333 15.4603 8.33333 15V13.75C8.33333 13.2898 8.70642 12.9167 9.16667 12.9167H10.8333C11.2936 12.9167 11.6667 13.2898 11.6667 13.75V15ZM11.6667 10.625C11.6667 11.0853 11.2936 11.4583 10.8333 11.4583H9.16667C8.70642 11.4583 8.33333 11.0853 8.33333 10.625V5C8.33333 4.53977 8.70642 4.16667 9.16667 4.16667H10.8333C11.2936 4.16667 11.6667 4.53977 11.6667 5V10.625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.46a91cb02ab9296db013afc69e118604.svg";
export { ForwardRef as ReactComponent };